import { render } from "./MapEditOptionsWelcomeMessage.vue?vue&type=template&id=3fdb5a15&scoped=true&bindings={\"modelValue\":\"props\",\"addwelcomeMessageLan\":\"data\",\"languages\":\"data\",\"mapData\":\"options\",\"welcomeMessageLanExists\":\"options\",\"addWelcomeMessage\":\"options\"}"
import script from "./MapEditOptionsWelcomeMessage.vue?vue&type=script&lang=js"
export * from "./MapEditOptionsWelcomeMessage.vue?vue&type=script&lang=js"

import "./MapEditOptionsWelcomeMessage.vue?vue&type=style&index=0&id=3fdb5a15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fdb5a15"

export default script